import React, { useRef, useState } from "react"
import { useNavigate } from "react-router-dom";
import styles from './Login.module.scss'
import { useAuth } from '../contexts/AuthContext';
import eventBus from "../utils/EventBus";
import Register from "./Register";
import ConfirmEmail from "./ConfirmEmail";
import ForgotPassword from "./ForgotPassword";
import VerifyEmail from "./VerifyEmail";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import useRegistrationStatus from '../Hooks/useRegistrationStatus';

export default function Login() {
    const usernameRef = useRef();
    const passwordRef = useRef();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const registrationEnabled = useRegistrationStatus();

    function handleRegisterClick() {
        eventBus.publish('modal',
            {
                title: "Register",
                content: <Register/>
            })
    }

    function handleForgotPasswordClick() {
        eventBus.publish('modal',
            {
                title: "Forgot password",
                content: <ForgotPassword/>
            })
    }

    function handleVerifyEmailClick() {
        eventBus.publish('modal',
            {
                title: "Verify your email",
                content: <VerifyEmail/>
            })
    }

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const result = await login(
                usernameRef.current.value,
                passwordRef.current.value
            );
            
            if (!result.success) {
                if (result.code === 'EMAIL_NOT_VERIFIED') {
                    eventBus.publish('modal', {
                        title: "Confirm your email",
                        content: <ConfirmEmail email={result.email}/>
                    })
                } else {
                    setError(result.error);
                }
            } else {
                // Close the modal and redirect to dashboard
                eventBus.publish('modal', null);
                navigate('/dashboard');
            }
        } catch (err) {
            setError('Failed to log in');
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className={styles.login}>
            <form className={styles.form} onSubmit={handleSubmit}>
                <div>
                    <h3 className={styles.title}>Login</h3>
                    {error && <div className={styles.error}>{error}</div>}
                    <label>Username</label>
                    <input ref={usernameRef} type="text" placeholder="Enter Username" required/>
                    <label>Password</label>
                    <div className={styles.passwordField}>
                        <input ref={passwordRef} type={showPassword ? 'text' : 'password'} placeholder="Enter Password" required/>
                        <button type="button" className={styles.toggleButton} onClick={() => setShowPassword(!showPassword)} aria-label={showPassword ? 'Hide password' : 'Show password'}>
                            <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                        </button>
                    </div>
                    <button type="submit" disabled={loading}>
                        {loading ? 'Logging in...' : 'Login'}
                    </button>
                    <div className={styles.registerLink}>
                        <button type="button" onClick={handleForgotPasswordClick} className={styles.linkButton}>
                            Forgot password?
                        </button>
                    </div>
                    <div className={styles.registerLink}>
                        <button type="button" onClick={handleVerifyEmailClick} className={styles.linkButton}>
                            Didn't verify your email?
                        </button>
                    </div>
                    {registrationEnabled && (
                        <div className={styles.registerLink}>
                            Don't have an account?{' '}
                            <button type="button" onClick={handleRegisterClick} className={styles.linkButton}>
                                Register
                            </button>
                        </div>
                    )}
                </div>
            </form>
        </div>
    )
}